export const restructureData = data => {
  const array = [];
  data.map(({ subscriptionId, subReferenceId }, index) =>
    array.push({
      key: index + 1,
      text: subscriptionId.toString(),
      value: {
        terminalId: subReferenceId.toString(),
        terminalRefId: subscriptionId.toString(),
      },
    }),
  );
  return array;
};

export const addFieldToArray = (array, data = '') => {
  const newArray = array;
  newArray.push(data);
  return newArray;
};

export const removeFieldFromArray = (array, index) => {
  const newArray = array;
  newArray.splice(index, 1);
  return newArray;
};
